import cutileiApi from './cutileiApi'
import Dre from './Dre'

/*
  Busca o que a DRE do ano precisa e devolve o extra de Dre.buildStatement.

  Era aqui que a tela montava tudo sozinha: 26 a 30 requisições por abertura, sendo 24 de
  comissão — `/schedules` e `/business_bills?detailed=true` mês a mês, em ondas de dois, porque
  disparar o ano inteiro de uma vez esgotava o pool de conexões da API e voltava 503. As comandas
  vinham inteiras, com todos os itens, só para serem somadas no navegador.

  Agora `GET /businesses/:id/dre?year=` devolve os insumos já somados por mês. A matemática da
  DRE continua aqui no front, em `Dre.buildStatement`: o servidor manda receita, custos, despesas,
  comissões e bônus, e a montagem da tabela (rótulos, ordem, análise vertical) não mudou de lugar.

  `previousEarnings` vem cru, no mesmo formato de `earnings`, porque o histórico do RBT12 sai dele
  por `Dre.getMonthlyRevenue` — a mesma conta que valia antes.
*/
export default class DreData {
  static async load({ businessId, year, requestAuth, signal }) {
    const { data } = await cutileiApi.get(
      `/businesses/${businessId}/dre?year=${year}`, { ...requestAuth, signal }
    )

    const { earnings, previousEarnings, costs, expenses, commissions, bonuses } = data
    const previousYearRevenue = Dre.getMonthlyRevenue(previousEarnings, Number(year) - 1)

    return {
      statement: Dre.buildStatement(earnings, year, {
        costs, expenses, commissions, bonuses, previousYearRevenue
      }),
      costs,
      expenses
    }
  }
}
